import { _rails } from '../../modules/constants';
import  {stringify}  from 'querystring';
import Template7 from "template7";
export default class events_buy extends EventedClass {
    constructor() {
        super();
        // TEMPLATES
        this.t7_sections_zones = null
        this.t7_not_numbered   = null
        // STATES
        this.isFirstTime = true
        this.current_zone = window.default_zn_id || null
        this.current_session = window.ss_id
        this.document  = $(document)
        this.scrollPos = {zone: null, y: 0}
        this.embebed   =  (window.location.search.match("embebed=(.+)&?") || [])
        this.numbered  = window.nb || false
        // ELEMENTS
        this.elem = {
            // LAYER SEATS
            seats: null,
            cart: null,
            page_toolbar: $('.page-toolbar'),
            button_external_cart_info: $('.items-cart'),
            layer_seats : $('#layer-seats'),
            layer_zone_info: $('.layer-zone-info'),
            btn_nav_next: $('#btn-nav-next'),
            btn_nav_prev: $('#btn-nav-back'),
            // SECTIONS MENU
            section_menu: $('#section-menu'),
            section_menu_close:   $('.page-sections-menu__close'),
            section_menu_info:   $('.page-sections-menu__info'),
            section_menu_content: $('.page-sections-menu__content'),
            // HELP
            section_information: $('#section-information'),
            section_information_close: $('.page-sections-info__close'),
            // CART
            section_cart: $('.page-sections-cart'),
            btn_cart_close: $('.btn-cart-close'),
            btn_open_cart: $('#seats-button-buy')
        }
        // CALLING INSTALL
        this.initialize();
        this._installEvents();
    }

    initialize() {
        const self = this
        this.elem.cart        = new App.classes.cartClass({parent: this});
        if (this.numbered)
            this.elem.seats   = new App.classes.containerTPVSeatsClass(this.elem.layer_seats , false); //mouseWheel = off ? he activat teclat
        else {
            this.elem.seats = new App.classes.containerTPVNotNumberedClass(this, this.elem.layer_seats); // NO NUMERADES
            // AMAGUEM NAVIGATOR
            this.elem.btn_nav_prev.hide();
            this.elem.btn_nav_next.hide();
        }
        this.elem.seats.initialize()

        // COMPILED TEMPLATES
        this._compileTemplates().then(()=>{
        // FIRST TIME
         if (this.current_zone){
             // CARREGUEM LA ZONA DIRECTAMENT SENSE MENU
             this.elem.section_menu.removeClass('open') // OCULTEM MENU
             this._fetchAll(true) // DEMANEM LES DADES
         }else{
             self._fetchSectionsZones(true)
         }

        }).catch( e =>{
            console.error("No s'han pogut compilar els templates")
        })
    }
    _installEvents() {
        // SEATS
        this.elem.seats.on("seats:added_seat",this._onSuccessAddedSeat.bind(this));
        this.elem.seats.on("seat:added_seat_error",this._onErrorAddedSeat.bind(this));
        // CART
        this.elem.cart.on("cart:success_ticket_remove",this._onSuccessRemoveTicketCart.bind(this));
        this.elem.cart.on("seat:error_ticket_remove",this._onErrorRemoveTicketCart.bind(this));
        this.elem.btn_cart_close.on('click', this._onClickCartClose.bind(this))
        this.elem.btn_open_cart.on('click', this._onClickCartOpen.bind(this))
        // REFRESH ALL
        this.on("ajax:fetch_all_error",this._onErrorAjaxRefreshAll.bind(this))

        // ACCIÓ DEL LES ZONES PER CARREGAR BUTAQUES
        this.elem.section_menu_content.on("click", ".zone", this._onClickZone.bind(this)) // LIVE
        // TANCA EL MENU DE SECCIONS
        this.elem.section_menu_close.on("click", this._onClickCloseMenu.bind(this))

        // OBRE EL MENU
        this.elem.page_toolbar.on("click", ".btn-menu", this._onClickMenu.bind(this)) // LIVE
        // TANCA EL IFRAME I RETORNA AL DETAIL
        this.elem.page_toolbar.on("click", ".btn-info", this._onClickCloseIframe.bind(this)) // LIVE
        // OBRE LA INFO LEGEND
        this.elem.page_toolbar.on("click", ".btn-help", this._onClickHelp.bind(this)) // LIVE
        // TANCA LA INFO LEGEND
        this.elem.section_information_close.on("click", this._onClickCloseInformation.bind(this))


        // SCROLL POSITION

        // SCROLL DOCUMENT POS
        this.document.on('scroll', this._onScrollDoc.bind(this))

        // NAVIGATOR
        this.elem.btn_nav_next.on('click', this._onClickNavNext.bind(this))
        this.elem.btn_nav_prev.on('click', this._onClickNavPrev.bind(this))

    }
    /*** EVENTS ***/
    _onClickZone(e){
        const id   = $(e.currentTarget).data('id')
        const info = $(e.currentTarget).data('name')
        this._scrollYByZone(id)
        this.current_zone = id || 0
        // PINTEM LA INFO DE LA ZONA
        this.elem.layer_zone_info.html(`<span>${info}</span>`).removeClass('hide')
        // ACTIVEM L'ACTUAL I FEM RESET ALS ALTRES
        $(e.currentTarget).addClass('active').parent().parent().find('.zone').not(e.currentTarget).removeClass('active')
        // TANQUEM MENU I DEMANEM LES BUTAQUES
        this.elem.section_menu.removeClass('open')
        this.unlockScrollBody();
        this._fetchAll(true)
    }
    /*** SEC MENU ***/
    _onClickCloseIframe(e){
        window.parent.postMessage({action:"close_frame"}, '*');
    }
    _onClickMenu(e){
        this.isFirstTime = false
        this.lockScrollBody()
        //this.elem.section_menu_close.removeClass('hide')
        //this.elem.section_menu_info.addClass('hide')
        this._fetchSectionsZones(true)
        this.elem.section_menu.addClass('open')
    }
    _onClickCloseMenu(e){
        this.unlockScrollBody();
        this.elem.section_menu.removeClass('open')
    }
    /*** CART ***/
    _onClickCartClose(e){
        this.unlockScrollBody()
        this.elem.section_cart.removeClass('open')
    }
    _onClickCartOpen(e){
        this.lockScrollBody()
        this.elem.section_cart.addClass('open')
    }
    /*** HELP ***/
    _onClickHelp(e){
        this.lockScrollBody()
        this.elem.section_information.addClass('open')
    }
    _onClickCloseInformation(e){
        this.unlockScrollBody()
        this.elem.section_information.removeClass('open')
    }

    /***  SEATS ***/
    _onSuccessAddedSeat(data){
        // FLASH NO NUMERADES
        if(!this.numbered) {
            App.utils.notify.success(App.messages.global.added_seat_not_numbered, ' ', {
                timeOut: 1500,
                positionClass: 'toast-top-right',
                preventDuplicates: true
            })
        }
        const self= this
       /* setImmediate(()=>{
            self._fetchAll(true)
        },300)*/
        self._fetchAll(true)
    }
    _onErrorAddedSeat(data){

        let msg = App.messages.global.errorAjax
        //COM UN FLASH TOAST INVALID
        if(data.status === 422 && data.hasOwnProperty('messages') ){
           msg = data.messages.message || msg
            // FLASH WARNING
            App.utils.notify.warning(msg, 'Avís', {
                timeOut: 3000,
                positionClass: 'toast-top-center',
                preventDuplicates: true
            })
         // CARTS ,COM UN MODAL JA QUE SON DEL CART (NOT PAYABLE; CANCELLED)
        }else if(data.status === 404 && data.hasOwnProperty('messages') ){
            msg = data.messages.message || msg
            this.elem.cart._paintMessage(msg, 0)
        }else{
            // DEFAULT ERROR
            this.elem.cart._paintMessage(msg, 2000)
        }

        this._fetchAll(false) // REFRESH DATA

    }
    /**** REFRESH ***/
    _onErrorAjaxRefreshAll(data){
        console.log(data)
        let msg = App.messages.global.errorAjax
        // CARTS ,COM UN MODAL JA QUE SON DEL CART (NOT PAYABLE; CANCELLED)
        if(data.status === 404 && data.hasOwnProperty('messages') && data.messages !=""){
            msg = data.messages.message || msg
            this.elem.cart._paintMessage(msg, 0)
            this._fetchAll(false)
        }else{
            // FLASH  404 NOT FOUND; ERROR
            App.utils.notify.error(msg, 'Error', {
                timeOut: 3000,
                positionClass: 'toast-top-full-width',
                preventDuplicates: true
            })
        }
    }
    /*** CART ***/
    _onSuccessRemoveTicketCart(data){
        const self= this
        /*setImmediate(()=>{
            self._fetchAll(true)
        },300)*/
        self._fetchAll(true)
    }
    _onErrorRemoveTicketCart(data){
        //console.log(data)
        let msg = App.messages.global.errorAjax
        //COM UN FLASH TOAST INVALID
        if(data.status === 422 && data.hasOwnProperty('messages') ){
            msg = data.messages.message  || msg
        }
        // CARTS ,COM UN MODAL JA QUE SON DEL CART (NOT PAYABLE; CANCELLED)
        if(data.status === 404 && data.hasOwnProperty('messages') ){
            msg = data.messages.message || msg
            this.elem.cart._paintMessage(msg, 0)
        }else{
            // FLASH
            App.utils.notify.error(msg, 'Error', {
                timeOut: 3000,
                positionClass: 'toast-top-full-width',
                preventDuplicates: true
            })
        }

        this._fetchAll(false)
    }

    /*** NAVIGATORS ***/
    _onClickNavNext(e){
        if (this.numbered) this.elem.seats.scroll.next()
    }
    _onClickNavPrev(e){
        if (this.numbered) this.elem.seats.scroll.prev()
    }
    _onScrollDoc(e){
        this.scrollPos.y = window.scrollY
    }
    /*** RENDERS ***/
    _renderSectionsZones(data){
        if (!data) return
        const  type = this.embebed.length > 1 &&  this.embebed[1] || "unknow";
        const  html = this.t7_sections_zones(data);
        this.elem.section_menu_content.html(html)
        // ACTIVEM EL SELECCIONAT ZONE ID
        $('[data-id="'+ this.current_zone+'"]').addClass('active')
        // ENVIEM L'ALTURA AL WIDGET
        //page-sections-menu__content
        window.parent.postMessage(JSON.stringify({
            cmd: type + ":height",
            value: this.elem.section_menu_content.height() + 60   // zones +( toolbar 40 +  20 margin)
        }), "*");
    }

    /*** FETCHES DATA ***/
    /**
     * ACCIÓ QUE RETORNA L'ESTAT DE LES SECCIONS I ZONES JUNTES
     * @param loader BOOL
     * @private
     */
    _fetchSectionsZones(loader=false){
        const self = this
        if (loader) App.utils.loaderON()
        let _url =_rails.url.resfresh_sections
        let payload= stringify({
            id:  this.current_session  //session id from global space
        })
        Rails.ajax({
            url: _url, type: "POST", data: payload,
            success: (data) => {
                self._renderSectionsZones(data)
            },
            error: (e) => {
                //self._renderSectionsZones({sections: null})
                //self.elem.section_menu.removeClass('open')
                App.utils.notify.error(App.messages.global.errorAjax , "Error", {
                    timeOut: 4000,
                    positionClass: "toast-top-full-width",
                    preventDuplicates: true
                })
            },
            complete: () => {
                App.utils.loaderOFF()
            }
        })
    }

    /**
     * ACCIÓ QUE RETORNA L'ESTAT ACTUAL DE TOT
     * @param loader BOOL
     * @private
     */
    _fetchAll(loader=false){
        const self = this
        if (loader) App.utils.loaderON()
        let _url =_rails.url.resfresh_all
        let payload= stringify({
            event_zone_id:  this.current_zone
        })
        Rails.ajax({
            url: _url, type: "POST", data: payload,
            success: (data) => {
                 self.renderAllData(data)
            },
            error: (response, statusText, xhr) => {
                self.trigger("ajax:fetch_all_error", {status: xhr.status, messages: response })
            },
            complete: () => {
                App.utils.loaderOFF()
            }
        })
    }
    renderAllData(data){
        try{
            // BUTAQUES
            console.log(data)
            if (this.numbered) this._renderAllSeats(data)        // LES NUMERADES
            if(!this.numbered) this._renderNotNumberedSeat(data) // NO NUEMRADES
            // CART
            this.elem.cart.refreshAll(data.cart)
            $(window).trigger('resize')
        }catch (e) {
          console.error("renderAllData->",e)
        }
    }
    /**
     * COMPILA LES PLANTILLES JS
     * @returns PROMISE
     * @private
     */
    _compileTemplates(){
        let self = this;
        return new Promise((resolve, reject) => {
            try{
                setTimeout(()=>{
                    self._compiledHelpertT7();
                    self.t7_sections_zones = Template7.compile(document.getElementById('section_zone_template').innerHTML);
                    self.t7_not_numbered   = Template7.compile(document.getElementById('not_numbered_seat_template').innerHTML);
                    resolve()
                },0)
            }catch (e) {
                console.error("Error at templates compiled", e)
                reject()
            }

        })

    }
    _compiledHelpertT7(){
        Template7.registerHelper('option', function (max, options){
            var options = "";
            for(var i = 1; i <= (max || 5); i++){
                var selected = (i == 1) ? "selected" : "";
                var entrada  = (i > 1) ? " entrades" : " entrada";
                options += '<option value="'+ i +'"'+ selected+'>'+ i + entrada+'</option>';
            }
            return options;
        });
    }

    /**
     * PINTEM TOTES LES BUTAQUES NUMERADES
     * @param json
     */
    _renderAllSeats(json) {
        let self = this;
        const type = self.embebed.length > 1 &&  self.embebed[1] || "unknow";
        const seats = json.seats
        const last_pos_y = self.scrollPos.y
        this.elem.seats.setJsonSeats(seats).then(()=>{
            self._paintSelectedSeatsFromCart(json);
            window.scrollTo({top: last_pos_y })
            // ENVIEM ALTURA DE PAGINA TOTAL CALCULADA AMB BUTAQUES AL WIDGET
            window.parent.postMessage(JSON.stringify({
                cmd: type + ":height",
                value: (this.elem.seats.$layer_seats.height() + 50) + (67 * 2 ) || 457  // seats + scenary + (toolbar + 10 margin * 2 )
            }), "*");
        }).catch(e=>{
            App.utils.notify.error(App.messages.global.errorOnLoadSeats);
        })
    }
    /**
     * PINTEM LA BUTACA NO NUMERADA
     * @param json
     */
    _renderNotNumberedSeat(json){

        let self   = this;
        const type = self.embebed.length > 1 &&  self.embebed[1] || "unknow";
        const html = this.t7_not_numbered(json.not_numbered);
        this.elem.layer_seats.html(html)
        // PINTEM LA INFO DE LA ZONA
        this.elem.layer_zone_info.html(`<span>${json.not_numbered.name}</span>`).removeClass('hide')
        // ENVIEM ALTURA DE PAGINA TOTAL CALCULADA AL WIDGET
        window.parent.postMessage(JSON.stringify({
            cmd: type + ":height",
            value: (this.elem.seats.$layer_seats.height() + 50) + (67 * 2 ) || 457  // seats + scenary + (toolbar + 10 margin * 2 )
        }), "*");

    }
    /**
     * ELIMINA TOTES LES BUTAQUES
     */
    resetSeats(){
        this.elem.seats.deleteElements()
    }
    lockScrollBody(){
        $(document.body).addClass('lock-scroll')
    }
    unlockScrollBody(){
        $(document.body).removeClass('lock-scroll')
    }
    /**
    * RESET SCROLL POS BY ZONE AND ID
    */
    _scrollYByZone(id){
        if (this.scrollPos.zone !== id ){
            this.scrollPos = {zone: id, y: 0}
            this.elem.seats.last_pos ={x: 0, y: 0}
        }else{
            this.scrollPos.zone = id
        }
    }
    /**
     * ACTUALITZA LES BUTAQUES  SELECCIONADES
     * QUE HI SON DINTRE DEL CART
     * @private
     */
    _paintSelectedSeatsFromCart(data){
        if (!data) return
        let $children = this.elem.layer_seats.find('.layer-seats__grid').children('.layer-seats__item-seat') // TOTES LES BUTAQUES
        if (data.hasOwnProperty('selected_seats')) {
            /** SELECCIONEM BUTAQUES **/
            data.selected_seats.forEach(function (seat) {
                $children.filter('[data-id="' + seat.id + '"]').addClass('selected');
            });
        }
        if (data.hasOwnProperty('blocked_seats')) {
            /** SELECCIONEM COVID **/
            data.blocked_seats.forEach(function (seat) {
                $children.filter('[data-id="' + seat.id + '"]').removeClass('status-blocked').addClass('status-pre-pending').data('state','pending');
            });
        }
    }
    _getDocumentHeigthDim=function() {
        const d =  document;
        const h= Math.max(
            Math.max(d.body.scrollHeight, d.documentElement.scrollHeight),
            Math.max(d.body.offsetHeight, d.documentElement.offsetHeight),
            Math.max(d.body.clientHeight, d.documentElement.clientHeight)
        );
        console.log(h)
        return h ;

    };
}